<script>
import { mapState } from "vuex"
import SearchTopBar from "@/components/global/SearchTopBar"
import Table from "@/components/shared/Table"
import IncidentModal from "@/components/global/IncidentModal"
import _ from "underscore"
import Config from "@/config"

export default {
  components: {
    SearchTopBar,
    Table,
    IncidentModal,
  },
  data() {
    return {
      debug: false,
      dateTimePlaceholder: "",
      displayName: "Sent from Manage Conferences",
      items: [],
      refreshTableInc: 0,
      columnFilterFields: [
        { key: "confId", label: "ID", sortable: true },
        { key: "confName", label: "Name", sortable: true },
        { key: "confComment", label: "Comment", sortable: true },
        { key: "confUrl", label: "URL", sortable: true },
        { key: "created", label: "Created", sortable: true },
        { key: "updated", label: "Updated", sortable: true },
      ],
      filters: [
        {
          id: "conferenceStatus",
          type: "publicationstatuspicker",
          value: {
            id: "conferenceStatus",
            clearable: false,
            value: "",
            defaultLabel: "Status",
          },
          cols: 2,
        },
        {
          id: "conferenceColumnpicker",
          type: "columnpicker",
          value: {
            id: "cPicker",
            clearable: false,
            value: "",
          },
          cols: 3,
        },
        {
          id: "conferenceTextSearch",
          type: "text",
          value: "", 
          cols: 7,
          placeholder: null,
        },
        {
          id: "topBarButtons",
          type: "buttongroup",
          cols: 12,
          style: "text-align: right;margin-top: 10px;",
          buttons: [
            {
              id: "createIncidentButton",
              type: "button",
              label: "Create Incident",
              variant: "light",
            },
            {
              id: "createProceedingButton",
              type: "button",
              label: "New",
              variant: "light",
            },

          ],
        },
      ],
      sortBy: "confId",
      sortDesc: false,
    }
  },
  computed: {
    ...mapState("publication", [
      "conferenceStatusFilter",
      "conferenceTextSearchFilter",
      "conferenceColumnFilter",
    ]),
    ...mapState("auth", [
      "role",
      "email",
    ]),
    incidentGroup() {
      return Config.publication.incidentGroup
    },
    results() {
      return {
        fields: [
          { key: "confId", label: "Id", sortable: true },
          { key: "confName", label: "Name", sortable: true },
          { key: "confStatus", label: "Status", sortable: true },
          { key: "confUrl", label: "URL", sortable: true },
          { key: "confComment", label: "Comment", sortable: true },
          { key: "created", label: "Created", sortable: true },
          { key: "updated", label: "Updated", sortable: true },
        ],
        records: this.searchResults,
      }
    },
  },
  watch: {
    conferenceColumnFilter(val) {
      _.each(this.filters, (filter) => {
        if (filter.id == "conferenceColumnpicker") {
          filter.value.value = val
          if (filter.value.value == "created" || filter.value.value == "updated") {
            this.dateTimePlaceholder = ">="
          } else {
            this.dateTimePlaceholder = "Search field..."
          }
        }
      })
    },
    conferenceStatusFilter(val) {
      _.each(this.filters, (filter) => {
        if (filter.id == "conferenceStatus") {
          filter.value.value = val
        }
      })
    },
    conferenceTextSearchFilter(val) {
      _.each(this.filters, (filter) => {
        if (filter.id == "conferenceTextSearch") {
          filter.value = val
        }
      })
    },
    dateTimePlaceholder(newVal) {
      this.filters = this.filters.map(filter => {
        if (filter.id === "conferenceTextSearch") {
          return { ...filter, placeholder: newVal }
        }
        return filter
      })
    },
  },
  created() {
    this.initialSearch()
  },
  methods: {
    initialSearch() {
      this.filters[0].value.value = this.conferenceStatusFilter
      this.filters[1].value.value = this.conferenceColumnFilter
      this.filters[2].value = this.conferenceTextSearchFilter
      this.refreshTableInc = this.refreshTableInc + 1
    },
    filterChange(data) {
      if (data.id == "conferenceStatus") {
        this.$store.dispatch("publication/setConferenceStatusCode", data.val.value)
      } else if (data.id == "conferenceColumnpicker") {
        this.$store.dispatch("publication/setConferenceColumn", data.val.value)
      } else if (data.id == "conferenceTextSearch") {
        this.$store.dispatch("publication/setConferenceTextSearches", data.val)
      }
    },
    filterOnClick(data) {
      if ((data.id == "conferenceTextSearch") && (data.val == "submit")) {
        this.refreshTableInc = this.refreshTableInc + 1
      } else if ((data.id == "conferenceTextSearch") && (data.val == "reset")) {
        this.$store.dispatch("publication/setConferenceStatusCode", "")
        this.$store.dispatch("publication/setConferenceColumn", "")
        this.$store.dispatch("publication/setConferenceTextSearches", "")
        this.refreshTableInc = this.refreshTableInc + 1
      } else if (data == "createIncidentButton") {
        if (this.email == "") {
          this.$store.dispatch("auth/retrieveEmail")
        }
        this.$bvModal.show("createIncidentModal")
      } else if (data == "createProceedingButton") {
        this.$router.push( {
          path: "/publicationadmin/createproceeding",
        })
      }
    },
    onRowClick(data) {
      this.$router.push( {
        path: `/publicationadmin/proceedingdetails/${data.confId}`,
      })
    },
  },
}
</script>

<template>
  <div id="FCSearch">
    <SearchTopBar :columnfilterfields="columnFilterFields" :filters="filters" @filterChange="filterChange" @filterClick="filterOnClick" @buttonClick="filterOnClick" />
    <div class="PageContent">
      <Table :fields="results.fields" :items="items" :refreshTable="refreshTableInc" searchAction="performProceedingsSearches" :sortBy="sortBy" :sortDesc="sortDesc" store="publication" @rowClick="onRowClick" />
    </div>
    <IncidentModal :group="incidentGroup" :displayName="displayName" />
  </div>
</template>

<style>
</style>
